import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Grid, Checkbox, Header, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { DragDropContext } from 'react-beautiful-dnd';
import { change, submit } from 'redux-form';
import classNames from 'classnames';
import qs from 'qs';
import isHotkey from 'is-hotkey';

import { Popup } from 'Common/Components';
import { LoadingBase, DirtyWrapper } from 'Components';
import { Toolbox } from 'Components/toolbox/Toolbox';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import {
  RecipeSearch,
  withRecipesSubscription,
  WEEKLY_NUTRIENTS,
} from 'Common/Components/RecipeSearch';
import {
  countTruthyKeys,
  extractTruthyKeys,
  formParseInt,
} from 'Common/FormHelper';
import { NutritionalStandardMap } from 'Common/Constants/NutritionalStandard';
import { ButtonGroup } from 'Common/Components/ButtonGroup';
import LassoSelection from 'Common/Components/LassoSelection/LassoSelection';
import { clearRecipes } from 'Common/Components/RecipeSearch/state/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import {
  EditMenuFieldEnum as Fields,
  RecipeFieldEnum as RecipeFields,
  GetAppliedMenuFieldEnum as GetAppliedMenuFields,
  ApplyCycleMenuFieldEnum as ApplyCycleMenuFields,
  CycleMenuRecipeFieldEnum as CycleMenuRecipeFields,
} from 'Common/FieldEnum';
import {
  EDIT_MENU_FORM_NAME,
  EDIT_RECIPE_FORM_NAME,
  InputMode,
} from 'Common/FormEnum';
import { MOD_KEY, NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import {
  setEditing,
  setEditCycleValues,
  setSaveSuccessful,
} from 'Pages/managemenu/state/listcycles/actions';
import { getIsDragging, getDraggingMeta } from 'State/selectors';
import * as CommonMenusSelectors from 'Pages/managemenu/state/common/selectors';
import { setIsDragging } from 'State/dragAndDrop/actions';
import {
  toggleLasso,
  toggleBlockOnClick,
} from 'Common/Components/LassoSelection/state/actions';
import * as CommonMenusActions from 'Pages/managemenu/state/common/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as EditMenuSelectors from 'Pages/managemenu/state/editmenu/selectors';
import {
  MnuEditMenuUserSettingsEnum,
  getValueFromSettings,
} from 'Common/UserSettings/helpers/helper';
import { setMnuEditMenuUserSettings } from 'Common/UserSettings/state/actions';
import { getMnuEditMenuUserSettings } from 'Common/UserSettings/state/selectors';
import * as EditMenuActions from 'Pages/managemenu/state/editmenu/actions';
import { getValueFromInputMode } from 'Common/GeneralHelper';
import {
  EDIT_MENU_QUERYSTRINGS,
  EDIT_MENU_TYPES,
} from 'Pages/managemenu/helpers/Constants';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import * as LassoSelectors from 'Common/Components/LassoSelection/state/selectors';
import 'Styles/pages/managemenu/editMenu.less';

import { EditMenuForm } from './components/EditMenuForm';
import { WeeklyAnalysisPanel } from './components/WeeklyAnalysisPanel';
import { DailyView } from './components/DailyView';
import { WeeklyView } from './components/WeeklyView';
import { MonthView } from './components/MonthView';
import { ApplyCycleMenuModal } from './components/ApplyCycleMenuModal';
import { UnApplyCycleMenuModal } from './components/UnApplyCycleMenuModal';
import { AnalysisReportModal } from './components/AnalysisReportModal';
import { ReimbursableMealModal } from './components/ReimbursableMealModal';
import { RecipeModal } from './components/RecipeModal';
import {
  VIEW_BY,
  UNCATEGORIZED_RECIPE_CATEGORY,
  PROJECTED_SERVINGS_MAX_LENGTH,
  ALACARTE_RECIPE_CATEGORY,
} from './constants';
import {
  formatCycleMenuHeaderText,
  getNumberOfWeeks,
  getMealsOnDay,
  canEditAppliedMenu,
} from './utilities';
import { ReplaceRemoveModal } from './components/ReplaceRemoveModal';

const isCopyHotkey = isHotkey('mod+c');
const isPasteHotkey = isHotkey('mod+v');
const isEscHotkey = isHotkey('esc');

const Modals = {
  ReplaceRemove: 'ReplaceRemove',
  RecipeSearch: 'RecipeSearch',
  ApplyModal: 'ApplyModal',
  UnApplyModal: 'UnApplyModal',
  AnalysisReportModal: 'AnalysisReportModal',
  RecipeModal: 'RecipeModal',
  ReimbursableMealModal: 'ReimbursableMealModal',
};

class EditMenu extends Component {
  constructor(props) {
    super(props);
    const { MnuEditMenuUserSettings } = props;

    this.state = {
      viewBy: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.ViewBy,
        VIEW_BY.MONTH
      ),
      showWeeklyMealStandards: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.ShowWeeklyMealStandards,
        true
      ),
      showDaysOfTheWeek: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.ShowDaysOfTheWeek,
        false
      ),
      showMealContributionReq: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.ShowMealContributions,
        true
      ),
      showHoverOver: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.ShowHoverOver,
        false
      ),
      // recipe search's show hover over checkbox
      disableHoverOver: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.SearchDisableHoverOver,
        true
      ),
      searchItemsOnMenus: getValueFromSettings(
        MnuEditMenuUserSettings,
        MnuEditMenuUserSettingsEnum.SearchItemsOnMenu,
        false
      ),
      selectedDays: {},
      currentWeek: 1,
      analyzeDay: 1,
      ready: false,
      dailyViewDay: 1,
      [Modals.ApplyModal]: false,
      [Modals.UnApplyModal]: false,
      [Modals.RecipeSearch]: false,
      [Modals.ReplaceRemove]: false,
      [Modals.AnalysisReportModal]: false,
      [Modals.RecipeModal]: false,
      [Modals.ReimbursableMealModal]: false,
    };
    this.searchDroppableId = 'recipe-list-droppable';
    this.recipeSearchRef = React.createRef();
    this.viewContainerRef = React.createRef();
  }

  async componentDidMount() {
    const { viewBy } = this.state;
    const { switchCycleMenuView, history } = this.props;

    if (this.menuId) {
      switchCycleMenuView(viewBy);
      await this.getMenu();
      await this.analyzeCycleMenu();
      this.setState({ ready: true });
      window.addEventListener('keydown', this.handleKeyDown, false);
      window.addEventListener('keydown', this.handleCopyPaste, false);
    } else {
      history.replace('/managemenu');
    }
  }

  componentWillUnmount() {
    const { resetMenu, clearRecipes, clearSelection, resetCopied } = this.props;

    resetMenu();
    clearRecipes();
    clearSelection();
    resetCopied();
    window.removeEventListener('keydown', this.handleKeyDown, false);
    window.removeEventListener('keydown', this.handleCopyPaste, false);
  }

  componentDidUpdate(prevProps) {
    const {
      menuDaysMap: prevMenuDaysMap,
      recipesById: prevRecipesById,
      reimbMealsByDayMap: prevReimbMealsByDayMap,
    } = prevProps;
    const {
      saveSuccessful,
      change,
      menuDaysMap,
      clearError,
      recipesById,
      reimbMealsByDayMap,
    } = this.props;

    if (!_.isEqual(prevMenuDaysMap, menuDaysMap)) {
      change(EDIT_MENU_FORM_NAME, Fields.MenuDaysMap, menuDaysMap);
    }

    if (!_.isEqual(prevRecipesById, recipesById)) {
      change(EDIT_MENU_FORM_NAME, Fields.RecipesById, recipesById);
    }

    if (!_.isEqual(prevReimbMealsByDayMap, reimbMealsByDayMap)) {
      change(
        EDIT_MENU_FORM_NAME,
        Fields.ReimbMealsByDayMap,
        reimbMealsByDayMap
      );
    }

    errorToast(this.props, prevProps, 'error', clearError);

    if (saveSuccessful && saveSuccessful !== prevProps.saveSuccessful) {
      createToast(toastType.success, 'Success', 'Saved Successfully.', true);

      this.props.setSaveSuccessful(false);
      this.props.resetDirty();
    }
  }

  handleCopyPaste = (e) => {
    if (isCopyHotkey(e)) {
      this.copy();
    }

    if (isPasteHotkey(e)) {
      this.paste();
    }

    if (isEscHotkey(e)) {
      this.removeAllSelections();
    }
  };

  get menuHeaderText() {
    const {
      menuTitle,
      fiscalYear,
      nutritionStandardId,
      servings,
      numberOfDays,
    } = this.props;

    const nutritionStandard = NutritionalStandardMap[nutritionStandardId];

    return formatCycleMenuHeaderText({
      menuTitle,
      fiscalYear,
      servings,
      numberOfDays,
      nutritionStandard,
    });
  }
  get queryParams() {
    const { location } = this.props;

    return qs.parse(location.search, { ignoreQueryPrefix: true });
  }

  get menuType() {
    return Number(this.queryParams[EDIT_MENU_QUERYSTRINGS.VIEW]);
  }

  get viewByOptions() {
    return [
      {
        label: 'Day',
        value: VIEW_BY.DAY,
      },
      {
        label: 'Week',
        value: VIEW_BY.WEEK,
      },
      {
        label: 'Month',
        value: VIEW_BY.MONTH,
      },
    ];
  }

  get menuId() {
    const { match } = this.props;
    return parseInt(_.get(match, 'params.menuId', 0), 10);
  }

  getMenu = () => {
    const { getCycleMenu, getAppliedMenu, getSchoolCalendar } = this.props;

    switch (this.menuType) {
      case EDIT_MENU_TYPES.CYCLE_MENU:
        return getCycleMenu(this.menuId);
      case EDIT_MENU_TYPES.APPLIED_MENU:
        getSchoolCalendar(this.queryParams[EDIT_MENU_QUERYSTRINGS.SITE_ID]);
        return getAppliedMenu({
          [GetAppliedMenuFields.StartDate]:
            this.queryParams[EDIT_MENU_QUERYSTRINGS.START_DATE],
          [GetAppliedMenuFields.EndDate]:
            this.queryParams[EDIT_MENU_QUERYSTRINGS.END_DATE],
          [GetAppliedMenuFields.SiteId]:
            this.queryParams[EDIT_MENU_QUERYSTRINGS.SITE_ID],
          [GetAppliedMenuFields.CycleMenuId]: this.menuId,
          [GetAppliedMenuFields.AnalysisDays]:
            this.queryParams[EDIT_MENU_QUERYSTRINGS.ANALYSIS_DAYS],
        });
      default:
        return null;
    }
  };

  getRecipeCategories = () => {
    const { recipeCategories } = this.props;

    return recipeCategories.concat([
      UNCATEGORIZED_RECIPE_CATEGORY,
      ALACARTE_RECIPE_CATEGORY,
    ]);
  };

  onWeekChange = (weekNumber) => (e) => {
    const { analysisDays } = this.props;
    const { viewBy } = this.state;

    const newState = { currentWeek: weekNumber };

    if (viewBy === VIEW_BY.DAY) {
      newState.dailyViewDay = 1 + analysisDays * (weekNumber - 1);
    }

    this.setState(newState);
  };

  openRecipe = async (recipeId) => {
    const { dispatch, isFormDirty, setNotificationDialog, isSharedMenu } =
      this.props;
    if (!isSharedMenu) {
      if (isFormDirty) {
        setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.SAVE_BEFORE_PROCEEDING,
          actionsToDispatchOnOk: [
            submit(EDIT_MENU_FORM_NAME),
            change(EDIT_RECIPE_FORM_NAME, RecipeFields.Id, recipeId),
            EditMenuActions.disableDeleteRecipe(true),
          ],
          functionsToRunOnOk: [() => this.openModal(Modals.RecipeModal)],
        });
      } else {
        dispatch(change(EDIT_RECIPE_FORM_NAME, RecipeFields.Id, recipeId));
        dispatch(EditMenuActions.disableDeleteRecipe(true));
        this.openModal(Modals.RecipeModal);
      }
    }
  };

  closeRecipe = async () => {
    const { disableDeleteRecipe } = this.props;
    this.setState({ ready: false });
    await this.getMenu();
    await this.analyzeCycleMenu();
    disableDeleteRecipe(false);
    this.setState({ ready: true });
    this.closeModal(Modals.RecipeModal);
  };

  handleKeyDown = (e) => {
    const { selectedRecipesById, deleteRecipeDisabled } = this.props;
    if (
      (e.key === 'Delete' || e.key === 'Backspace') &&
      Object.keys(selectedRecipesById).length &&
      !deleteRecipeDisabled
    ) {
      this.deleteSelectedRecipes();
    }
  };

  deleteSelectedRecipes = () => {
    const { selectedRecipesById, setNotificationDialog } = this.props;

    if (Object.keys(selectedRecipesById).length > 0) {
      setNotificationDialog({
        ...NOTIFICATION_DIALOG_MESSAGES.DELETE_MENU_ITEMS,
        actionsToDispatchOnOk: [
          EditMenuActions.deleteSelectedRecipes(),
          EditMenuActions.analyzeCycleMenu(this.getAnalyzeCycleMenuParams()),
        ],
      });
    }
  };

  resetViewScrollPosition = () => {
    if (this.viewContainerRef && this.viewContainerRef.current) {
      this.viewContainerRef.current.scroll(0, 0);
    }
  };

  updateUserSettings = (key, value) => {
    const { MnuEditMenuUserSettings, setMnuEditMenuUserSettings } = this.props;

    setMnuEditMenuUserSettings({
      ...MnuEditMenuUserSettings,
      [key]: value,
    });
  };

  onViewByChange = (e, option) => {
    const { analysisDays, switchCycleMenuView } = this.props;
    const { viewBy: currentViewBy, selectedDays, currentWeek } = this.state;
    const newState = { viewBy: option, analyzeDay: 1 };
    const days = Object.keys(selectedDays).filter((k) => selectedDays[k]);
    const defaultDay = 1 + analysisDays * (currentWeek - 1);

    if (currentViewBy === VIEW_BY.MONTH) {
      if (days.length > 0) {
        const dayToDisplay = Math.min(...days);
        const week = getNumberOfWeeks(dayToDisplay, analysisDays);

        if (week !== currentWeek) {
          newState.currentWeek = week;
        }

        newState.dailyViewDay = dayToDisplay;
      } else {
        newState.dailyViewDay = defaultDay;
      }
    } else if (currentViewBy === VIEW_BY.WEEK && option === VIEW_BY.DAY) {
      if (days.length > 0) {
        const selectedDaysInWeek = days.filter((day) => {
          const week = getNumberOfWeeks(day, analysisDays);

          return week === currentWeek;
        });

        if (selectedDaysInWeek.length > 0) {
          const dayToDisplay = Math.min(...selectedDaysInWeek);
          newState.dailyViewDay = dayToDisplay;
        } else {
          newState.dailyViewDay = defaultDay;
        }
      } else {
        newState.dailyViewDay = defaultDay;
      }
    }

    this.setState(newState, () => {
      switchCycleMenuView(option);
      if ((option === VIEW_BY.DAY) ^ (currentViewBy === VIEW_BY.DAY)) {
        this.analyzeCycleMenu();
      }
      this.updateUserSettings(MnuEditMenuUserSettingsEnum.ViewBy, option);
      requestAnimationFrame(this.resetViewScrollPosition);
    });
  };

  onShowMealStandardsChange = () => {
    const nextValue = !this.state.showWeeklyMealStandards;
    this.setState({
      showWeeklyMealStandards: nextValue,
    });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.ShowWeeklyMealStandards,
      nextValue
    );
  };

  onShowDaysOfWeekChange = () => {
    const nextValue = !this.state.showDaysOfTheWeek;
    this.setState({
      showDaysOfTheWeek: nextValue,
    });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.ShowDaysOfTheWeek,
      nextValue
    );
  };

  onMealContributionChange = () => {
    const nextValue = !this.state.showMealContributionReq;
    this.setState({
      showMealContributionReq: nextValue,
    });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.ShowMealContributions,
      nextValue
    );
  };

  /** Recipe Search Hover Over */
  onDisableHoverOver = (nextValue) => {
    this.setState({ disableHoverOver: nextValue });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.SearchDisableHoverOver,
      nextValue
    );
  };

  onSearchItemsOnMenuChange = (nextValue) => {
    this.setState({ searchItemsOnMenus: nextValue });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.SearchItemsOnMenu,
      nextValue
    );
  };

  onDragNDropClick = () => {
    this.props.disableDeleteRecipe(true);

    if (this.state[Modals.RecipeSearch]) {
      this.closeModal(Modals.RecipeSearch);
    } else {
      this.openModal(Modals.RecipeSearch);
    }
  };

  onSearchCloseClick = () => {
    this.props.disableDeleteRecipe(false);
    this.closeModal(Modals.RecipeSearch);
  };

  onRecipeSearchUnmount = () => {
    const { clearRecipes } = this.props;

    clearRecipes();
  };

  onShowHoverOverChange = () => {
    const nextValue = !this.state.showHoverOver;
    this.setState({ showHoverOver: nextValue });
    this.updateUserSettings(
      MnuEditMenuUserSettingsEnum.ShowHoverOver,
      nextValue
    );
  };

  get toolboxProps() {
    const queryParams = {
      [EDIT_MENU_QUERYSTRINGS.VIEW]: this.menuType,
    };
    const queryString = qs.stringify(queryParams);

    const rightButtons =
      this.menuType === EDIT_MENU_TYPES.APPLIED_MENU
        ? []
        : [
            {
              content: 'Analysis Report',
              onClick: () => {
                this.openModal(Modals.AnalysisReportModal);
              },
            },
          ];

    return {
      backButtonProps: {
        shown: true,
        path: `/managemenu?${queryString}`,
        watchedForm: EDIT_MENU_FORM_NAME,
      },
      shown: true,
      isReadOnly: this.isReadOnly,
      formName: EDIT_MENU_FORM_NAME,
      className: 'menu-toolbox',
      rightButtons,
    };
  }

  onEditClick = (showDirtyLinkConfirm) => (e) => {
    const {
      setEditCycleValues,
      numberOfDays,
      menuTitle,
      fiscalYear,
      nutritionStandardId,
      servings,
      analysisDays,
      setEditing,
      resetDirty,
    } = this.props;

    showDirtyLinkConfirm('/managemenu', () => {
      resetDirty();
      setEditing(true);
      setEditCycleValues({
        id: this.menuId,
        description: menuTitle,
        numberOfDays,
        nutritionStandardId,
        fiscalYear,
        servings,
        analysisDays,
      });
    });
  };

  onDragEnd = (result) => {
    this.props.setIsDragging(false);

    const {
      addRecipeToMenu,
      moveRecipe,
      reorderMenuItems,
      servings,
      combineRecipe,
      addToMenuCombineRecipe,
    } = this.props;

    const { selectedDays } = this.state;
    const { source, destination, draggableId, combine } = result;

    const searchDroppableId = this.searchDroppableId;

    if (combine) {
      if (
        source.droppableId === searchDroppableId &&
        source.droppableId !== combine.droppableId
      ) {
        const added = addToMenuCombineRecipe({
          to: combine.draggableId,
          toDay: combine.droppableId,
          recipeIndex: source.index,
          menuId: this.menuId,
          servings,
        });
        if (added) {
          this.analyzeCycleMenu();
        }
      } else {
        const combined = combineRecipe({
          from: draggableId,
          fromDay: source.droppableId,
          to: combine.draggableId,
        });

        if (combined) {
          this.analyzeCycleMenu();
        }
      }
    } else {
      if (!destination) {
        return;
      }

      // move to first position if moving above the first header
      if (destination.index === 0) {
        destination.index = 1;
      }

      if (
        source.droppableId === searchDroppableId &&
        source.droppableId !== destination.droppableId
      ) {
        // Dropping from recipe search
        const dayNumber = destination.droppableId;
        const newSelectedDays = { ...selectedDays };
        const added = addRecipeToMenu({
          menuId: this.menuId,
          recipeIndex: source.index,
          droppableDestination: destination,
          dayNumber,
          servings,
          draggableId,
        });

        if (added) {
          this.analyzeCycleMenu();
        }

        if (newSelectedDays[dayNumber]) {
          newSelectedDays[dayNumber] = false;
        }

        this.setState({ selectedDays: newSelectedDays });
      } else if (
        source.droppableId !== searchDroppableId &&
        source.droppableId === destination.droppableId
      ) {
        // reorder if items are on a cycle menu day
        reorderMenuItems({
          droppableSource: source,
          droppableDestination: destination,
          draggableId,
        });
      } else {
        // Moving from day to day
        const moved = moveRecipe({
          droppableSource: source,
          droppableDestination: destination,
          draggableId,
        });

        if (moved) {
          this.analyzeCycleMenu();
        }
      }
    }
  };

  onDayClick = (day) => {
    const { selectedDays } = this.state;
    const { isDragging, menuDaysMap, unselectMenuItems, blockOnClick } =
      this.props;
    if (!isDragging && !blockOnClick && !this.isReadOnly) {
      const nextSelected = !selectedDays[day];
      const newSelectedDays = {
        ...selectedDays,
        [day]: nextSelected,
      };

      this.setState({ selectedDays: newSelectedDays });

      if (!nextSelected) {
        const itemsOnDay = menuDaysMap[day];
        unselectMenuItems(itemsOnDay);
      } else {
        this.selectMenuItems(menuDaysMap[day]);
      }
    }
  };

  onAddRecipeClick = (recipeIndex) => {
    const { addRecipeToDays, servings, analysisDays, editableAppliedDays } =
      this.props;
    const {
      selectedDays: selectedDaysMap,
      viewBy,
      dailyViewDay,
      currentWeek,
    } = this.state;

    let added = false;

    if (viewBy === VIEW_BY.DAY) {
      const canAdd =
        this.menuType === EDIT_MENU_TYPES.APPLIED_MENU
          ? editableAppliedDays[dailyViewDay]
          : true;

      if (canAdd) {
        // add to just the current day on the day view
        [added] = addRecipeToDays({
          menuId: this.menuId,
          recipeIndex,
          selectedDays: [dailyViewDay],
          servings,
        });
      }
    } else if (viewBy === VIEW_BY.WEEK) {
      const startDay = 1 + (currentWeek - 1) * analysisDays;
      const endDay = currentWeek * analysisDays;
      const newSelectedDaysMap = { ...selectedDaysMap };
      const selectedDays = [];

      for (let i = startDay; i <= endDay; i++) {
        if (selectedDaysMap[i]) {
          selectedDays.push(i);
          newSelectedDaysMap[i] = false;
        }
      }

      [added] = addRecipeToDays({
        menuId: this.menuId,
        recipeIndex,
        selectedDays,
        servings,
      });

      this.setState({ selectedDays: newSelectedDaysMap });
    } else if (viewBy === VIEW_BY.MONTH) {
      const selectedDays = Object.keys(selectedDaysMap).reduce((acc, value) => {
        if (selectedDaysMap[value]) {
          acc.push(parseInt(value, 10));
        }
        return acc;
      }, []);

      [added] = addRecipeToDays({
        menuId: this.menuId,
        recipeIndex,
        selectedDays,
        servings,
      });

      this.resetSelectedDays();
    }

    if (added) {
      this.analyzeCycleMenu();
    }
  };

  resetSelectedDays = () => {
    this.setState({ selectedDays: {} });
  };

  onApplyClick = (e) => {
    this.props.disableDeleteRecipe(true);
    this.openModal(Modals.ApplyModal);
  };

  onUnApplyClick = (e) => {
    this.props.disableDeleteRecipe(true);
    this.openModal(Modals.UnApplyModal);
  };

  onApplyClose = (e) => {
    this.props.disableDeleteRecipe(false);
    this.closeModal(Modals.ApplyModal);
  };

  onUnApplyClose = (e) => {
    this.props.disableDeleteRecipe(false);
    this.closeModal(Modals.UnApplyModal);
  };

  onDragStart = (event) => {
    this.props.setIsDragging(true, event);
  };

  getAnalyzeCycleMenuParams() {
    const { analysisDays } = this.props;
    const { viewBy, analyzeDay } = this.state;

    return {
      cycleMenuId: this.menuId,
      analyzeDay: viewBy === VIEW_BY.DAY ? analyzeDay : 0,
      analysisDays,
    };
  }

  onDayViewDayChange = (day) => {
    const { analysisDays } = this.props;
    const { currentWeek, dailyViewDay: currentDay } = this.state;
    const newState = { dailyViewDay: day, analyzeDay: day };

    const week = getNumberOfWeeks(day, analysisDays);

    if (week !== currentWeek) {
      newState.currentWeek = week;
    }

    if (currentWeek !== week || currentDay !== day) {
      this.setState(newState, this.analyzeCycleMenu);
    }
  };

  analyzeCycleMenu = () => {
    const { analyzeCycleMenu } = this.props;

    return analyzeCycleMenu(this.getAnalyzeCycleMenuParams());
  };

  debouncedAnalyzeCycleMenu = _.debounce(this.analyzeCycleMenu, 500);

  onApplyModalClose = () => {
    this.props.disableDeleteRecipe(false);
    this.closeModal(Modals.ApplyModal);
  };

  deleteRecipe = (recipe) => {
    const { setNotificationDialog } = this.props;
    const { draggableId } = recipe;

    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DELETE_MENU_ITEM,
      actionsToDispatchOnOk: [
        EditMenuActions.deleteRecipes([draggableId]),
        EditMenuActions.analyzeCycleMenu(this.getAnalyzeCycleMenuParams()),
      ],
    });
  };

  bulkDeleteRecipes = (recipes) => {
    const { setNotificationDialog } = this.props;

    const actions = [];

    const ids = recipes.map((recipe) => {
      const { draggableId } = recipe;
      return draggableId;
    });

    actions.push(EditMenuActions.deleteRecipes(ids));
    actions.push(
      EditMenuActions.analyzeCycleMenu(this.getAnalyzeCycleMenuParams())
    );
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DELETE_MULTIPLE_MENU_ITEMS,
      actionsToDispatchOnOk: actions,
    });
  };

  hideRecipe = (recipeDraggableId, displayOnCalendar) => {
    const { changeRecipeDisplayOnCalendar } = this.props;

    changeRecipeDisplayOnCalendar(recipeDraggableId, displayOnCalendar);
  };

  bulkHideRecipes = (recipes) => {
    const { changeRecipeDisplayOnCalendar } = this.props;

    recipes.forEach((recipe) =>
      changeRecipeDisplayOnCalendar(
        recipe.recipeDraggableId,
        recipe.displayOnCalendar
      )
    );
  };

  onProjectedServingsChange = (recipeDraggableId) => (e) => {
    const { changeProjectedServings, servings, changeServingsPercentage } =
      this.props;
    const {
      target: { value },
    } = e;
    const projectedServings = formParseInt(value);

    if (projectedServings >= 0) {
      let percentage = Math.floor((projectedServings / servings) * 100);
      const percentageStr = String(percentage);

      if (percentageStr.length > PROJECTED_SERVINGS_MAX_LENGTH) {
        percentage = percentageStr.slice(0, PROJECTED_SERVINGS_MAX_LENGTH);
      }

      changeProjectedServings(recipeDraggableId, projectedServings);
      changeServingsPercentage(recipeDraggableId, percentage);
      this.debouncedAnalyzeCycleMenu();
    }
  };

  onProjectedServingsBlur = (recipeDraggableId) => (e) => {
    const { changeProjectedServings } = this.props;
    const {
      target: { value },
    } = e;

    if (!value) {
      changeProjectedServings(recipeDraggableId, 0);
    }
  };

  onProjectedServingsPercentageChange = (recipeDraggableId) => (e) => {
    const { changeServingsPercentage, changeProjectedServings, servings } =
      this.props;
    const {
      target: { value },
    } = e;

    if (!value) {
      changeProjectedServings(recipeDraggableId, 0);
      changeServingsPercentage(recipeDraggableId, value);
      this.debouncedAnalyzeCycleMenu();
      return;
    }

    const pattern = /^((\d+(\.\d*)?)|(\.\d+))$/;

    if (pattern.test(value)) {
      changeServingsPercentage(recipeDraggableId, value);
      const percentage = parseFloat(value);
      const projectedServings = Math.floor((servings * percentage) / 100);

      // Check if projected servings will exceed the max length
      const projectedServingsStr = String(projectedServings);
      if (projectedServingsStr.length > PROJECTED_SERVINGS_MAX_LENGTH) {
        changeProjectedServings(
          recipeDraggableId,
          Number(projectedServingsStr.slice(0, PROJECTED_SERVINGS_MAX_LENGTH))
        );
      } else {
        changeProjectedServings(recipeDraggableId, projectedServings);
      }

      this.debouncedAnalyzeCycleMenu();
    }
  };

  onProjectedServingsPercentageBlur = (recipeDraggableId) => (e) => {
    const { changeServingsPercentage } = this.props;
    const {
      target: { value },
    } = e;

    if (!value) {
      changeServingsPercentage(recipeDraggableId, 0);
    }
  };

  onQtyOfPortionChange = (recipeDraggableId) => (e) => {
    const { changeQtyOfPortion } = this.props;
    const {
      target: { value },
    } = e;

    const qtyOfPortion = getValueFromInputMode(
      InputMode.Decimal,
      [6, 4],
      value
    );

    changeQtyOfPortion(recipeDraggableId, qtyOfPortion);
    this.debouncedAnalyzeCycleMenu();
  };

  onQtyOfPortionBlur = (recipeDraggableId) => (e) => {
    const { changeQtyOfPortion } = this.props;
    const {
      target: { value },
    } = e;

    if (!value || isNaN(value)) {
      changeQtyOfPortion(recipeDraggableId, 0);
      this.debouncedAnalyzeCycleMenu();
    }
  };

  onRequirementClick = (requirement) => {
    const weeklyNutrient = WEEKLY_NUTRIENTS.find(
      (x) => x.Description === requirement.Description
    );

    if (weeklyNutrient) {
      this.openModal(Modals.RecipeSearch, () => {
        if (this.recipeSearchRef && this.recipeSearchRef.current) {
          this.recipeSearchRef.current.openLeftPanel();
          this.recipeSearchRef.current.onWeeklyNutrientChange(null, {
            value: weeklyNutrient.Id,
          });
        }
      });
    }
  };

  onToggleRecipeAlacarte = (recipeDraggableId) => () => {
    const { toggleRecipeAlacarte } = this.props;

    toggleRecipeAlacarte(recipeDraggableId);
    this.debouncedAnalyzeCycleMenu();
  };

  renderWeeklyAnalysisPanel() {
    const { nutritionStandardId, weeklyRequirements, analyzing, lassoMode } =
      this.props;
    const { showWeeklyMealStandards, currentWeek } = this.state;

    if (!showWeeklyMealStandards || !weeklyRequirements) {
      return null;
    }

    const nutritionStandard = NutritionalStandardMap[nutritionStandardId];

    return (
      <Grid.Column width={4} className="edit-cycle-analysis-panel-col">
        <WeeklyAnalysisPanel
          weekNumber={currentWeek}
          nutritionStandard={nutritionStandard}
          weeklyRequirements={weeklyRequirements}
          analyzing={analyzing}
          onRequirementClick={this.onRequirementClick}
          lassoMode={lassoMode}
        />
      </Grid.Column>
    );
  }

  onRecipeSearchKeyDown = (e) => {
    const { key } = e;

    if (key === 'Delete' || key === 'Backspace') {
      // Avoid allowing deleting recipes when typing into recipe search
      e.stopPropagation();
    }
  };

  removeChild = (childId, parentId) => {
    const { setNotificationDialog } = this.props;
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DETACH_RECIPE,
      actionsToDispatchOnOk: [EditMenuActions.removeChild(childId, parentId)],
    });
  };

  showReimbMealsModal = (dayNumber) => {
    const { disableDeleteRecipe } = this.props;
    this.onDayViewDayChange(dayNumber);
    this.openModal(Modals.ReimbursableMealModal);
    disableDeleteRecipe(true);
  };

  closeReimbursableMealModal = () => {
    const { disableDeleteRecipe } = this.props;
    this.closeModal(Modals.ReimbursableMealModal);
    disableDeleteRecipe(false);
    this.debouncedAnalyzeCycleMenu();
  };

  selectMenuItems = (ids) => {
    const { selectedDays } = this.state;
    const { selectMenuItems, recipesById } = this.props;

    const daysWithSelectedRecipes = {};

    extractTruthyKeys(ids).forEach((id) => {
      const recipe = recipesById[id];
      if (recipe) {
        const day = recipe[CycleMenuRecipeFields.DayNumber];
        daysWithSelectedRecipes[day] = false;
      }
    });

    const daysToUnselect = _.intersection(
      extractTruthyKeys(selectedDays),
      Object.keys(daysWithSelectedRecipes)
    );

    if (daysToUnselect.length > 0) {
      const nextSelectedDays = { ...selectedDays };
      daysToUnselect.forEach((day) => {
        nextSelectedDays[day] = false;
      });
      this.setState({ selectedDays: nextSelectedDays });
    }

    selectMenuItems(ids);
  };

  selectMenuItem = (id) => {
    const { selectedDays } = this.state;
    const { selectMenuItem, recipesById } = this.props;
    const recipe = recipesById[id];

    if (recipe) {
      const day = recipe[CycleMenuRecipeFields.DayNumber];
      this.setState({ selectedDays: { ...selectedDays, [day]: false } });
    }

    selectMenuItem(id);
  };

  getViewProps = () => {
    const {
      numberOfDays,
      analysisDays,
      weeklyRequirements,
      unmetDailyRequirements,
      analyzing,
      menuDaysMap,
      recipesById,
      servings,
      selectedRecipesById,
      clearSelection,
      dailyContributions,
      isDragging,
      draggingMeta,
      searchResults,
      recipeCountByDayMap,
      editableAppliedDays,
      copiedDays,
      copiedRecipesById,
      lassoMode,
      schoolCalendar,
    } = this.props;

    const {
      currentWeek,
      showHoverOver,
      showDaysOfTheWeek,
      showMealContributionReq,
      selectedDays,
      dailyViewDay,
    } = this.state;

    return {
      weekNumber: currentWeek,
      menuDaysMap,
      recipesById,
      analysisDays,
      numberOfDays,
      recipeCategories: this.getRecipeCategories(),
      currentWeek,
      analyzing,
      onWeekChange: this.onWeekChange,
      isReadOnly: this.isReadOnly,
      onDeleteClick: this.deleteRecipe,
      onBulkDeleteClick: this.bulkDeleteRecipes,
      onHideClick: this.hideRecipe,
      onBulkHideClick: this.bulkHideRecipes,
      disableHover: !showHoverOver,
      plannedServings: servings,
      onProjectedServingsChange: this.onProjectedServingsChange,
      onProjectedServingsBlur: this.onProjectedServingsBlur,
      onProjectedServingsPercentageChange:
        this.onProjectedServingsPercentageChange,
      onProjectedServingsPercentageBlur: this.onProjectedServingsPercentageBlur,
      selectedRecipesById,
      copiedRecipesById,
      selectMenuItem: this.selectMenuItem,
      clearSelection,
      showDaysOfTheWeek,
      unmetDailyRequirements,
      showMealContributionReq,
      weeklyRequirements,
      onQtyOfPortionChange: this.onQtyOfPortionChange,
      onQtyOfPortionBlur: this.onQtyOfPortionBlur,
      openRecipe: this.openRecipe,
      selectedDays,
      copiedDays,
      onDayClick: this.onDayClick,
      dailyContributions,
      onDayViewDayChange: this.onDayViewDayChange,
      currentDay: dailyViewDay,
      onToggleRecipeAlacarte: this.onToggleRecipeAlacarte,
      isDragging,
      draggingMeta,
      removeChild: this.removeChild,
      searchResults,
      searchDroppableId: this.searchDroppableId,
      recipeCountByDayMap,
      showReimbMealsModal: this.showReimbMealsModal,
      menuType: this.menuType,
      queryParams: this.queryParams,
      editableAppliedDays,
      lassoMode,
      schoolCalendar,
    };
  };

  renderMenuOptions() {
    const { weeklyRequirements } = this.props;
    const {
      showWeeklyMealStandards,
      showDaysOfTheWeek,
      showMealContributionReq,
      showHoverOver,
      viewBy,
    } = this.state;

    return (
      <Grid padded>
        <Grid.Row>
          <Grid.Column width={16} className="menu-calendar-options-container">
            <div className="menu-calendar-option">
              <Checkbox
                className="menu-calendar-checkbox"
                label="Show meal contribution requirements"
                onChange={this.onMealContributionChange}
                checked={showMealContributionReq}
              />
            </div>
            {weeklyRequirements && (
              <div className="menu-calendar-option">
                <Checkbox
                  className="menu-calendar-checkbox"
                  label="Show Weekly Meal Standards"
                  onChange={this.onShowMealStandardsChange}
                  checked={showWeeklyMealStandards}
                />
              </div>
            )}
            <div className="menu-calendar-option">
              <Checkbox
                className="menu-calendar-checkbox"
                label="Show Days of the Week"
                onChange={this.onShowDaysOfWeekChange}
                checked={showDaysOfTheWeek}
              />
            </div>
            <div className="menu-calendar-option">
              <Checkbox
                className="menu-calendar-checkbox"
                label="Show Hover Over"
                onChange={this.onShowHoverOverChange}
                checked={showHoverOver}
              />
            </div>
            <div className="menu-calendar-option">
              <span className="menu-btn-group-label">View By:</span>
              <ButtonGroup
                options={this.viewByOptions}
                onChange={this.onViewByChange}
                value={viewBy}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderView() {
    const { weeklyRequirements } = this.props;

    const { showWeeklyMealStandards, viewBy } = this.state;

    const viewWidth = showWeeklyMealStandards && weeklyRequirements ? 12 : 16;

    let View = null;

    switch (viewBy) {
      case VIEW_BY.WEEK:
        View = WeeklyView;
        break;
      case VIEW_BY.DAY:
        View = DailyView;
        break;
      case VIEW_BY.MONTH:
      default:
        View = MonthView;
        break;
    }

    return (
      <React.Fragment>
        <Grid.Column
          className={classNames('edit-cycle-menu-wrapper', {
            'panel-visible': showWeeklyMealStandards && weeklyRequirements,
          })}
          width={viewWidth}
        >
          <div className="edit-cycle-menu-view" ref={this.viewContainerRef}>
            <View key={viewBy} {...this.getViewProps()} />
          </div>
        </Grid.Column>
        {showWeeklyMealStandards && this.renderWeeklyAnalysisPanel()}
      </React.Fragment>
    );
  }

  saveMenu = async (values) => {
    const {
      saveCycleMenu,
      saveAppliedMenu,
      checkApplyCycleMenu,
      setNotificationDialog,
    } = this.props;

    if (this.menuType === EDIT_MENU_TYPES.CYCLE_MENU) {
      saveCycleMenu(values);
    } else if (this.menuType === EDIT_MENU_TYPES.APPLIED_MENU) {
      const startDate = this.queryParams[EDIT_MENU_QUERYSTRINGS.START_DATE];
      const endDate = this.queryParams[EDIT_MENU_QUERYSTRINGS.END_DATE];
      const siteId = this.queryParams[EDIT_MENU_QUERYSTRINGS.SITE_ID];
      const res = await checkApplyCycleMenu({
        [ApplyCycleMenuFields.CycleMenuId]: this.menuId,
        [ApplyCycleMenuFields.StartDateTime]: startDate,
        [ApplyCycleMenuFields.EndDateTime]: endDate,
        [ApplyCycleMenuFields.SiteIds]: [siteId],
        [ApplyCycleMenuFields.StartDay]: 1,
      });
      const saveAppliedMenuValues = {
        cycleMenuId: this.menuId,
        startDate,
        endDate,
        siteId,
        nutritionStandardId:
          this.queryParams[EDIT_MENU_QUERYSTRINGS.NUTRITION_STANDARD_ID],
        description: this.queryParams[EDIT_MENU_QUERYSTRINGS.DESCRIPTION],
      };

      if (res) {
        if (res.hasProdRecords) {
          setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.APPLIED_MENU_HAS_PRODUCTION_RECORDS,
            functionsToRunOnOk: [() => saveAppliedMenu(saveAppliedMenuValues)],
          });
        } else {
          saveAppliedMenu(saveAppliedMenuValues);
        }
      }
    }
  };

  get allDaysSelected() {
    const { selectedDays } = this.state;
    const { numberOfDays, editableAppliedDays } = this.props;

    const isAppliedMenus = this.menuType === EDIT_MENU_TYPES.APPLIED_MENU;

    return isAppliedMenus
      ? countTruthyKeys(selectedDays) === countTruthyKeys(editableAppliedDays)
      : countTruthyKeys(selectedDays) === numberOfDays;
  }

  selectAllDays = () => {
    const { allDaysSelected } = this;
    const { numberOfDays, editableAppliedDays } = this.props;

    const nextSelectedDays = {};

    for (let i = 1; i < numberOfDays + 1; i += 1) {
      const canEdit = canEditAppliedMenu({
        menuType: this.menuType,
        editableAppliedDays,
        dayNumber: i,
      });

      nextSelectedDays[i] = canEdit ? !allDaysSelected : false;
    }

    this.setState({ selectedDays: nextSelectedDays });
  };

  copy = () => {
    const { selectedDays } = this.state;
    const { copy, selectedRecipesById, clearSelection } = this.props;

    copy({
      days: selectedDays,
      recipes: selectedRecipesById,
    });

    clearSelection();
    this.resetSelectedDays();
  };

  paste = () => {
    const {
      selectedDays,
      viewBy: currentViewBy,
      dailyViewDay: currentDay,
    } = this.state;
    const { paste, copiedRecipesById, copiedDays, servings } = this.props;

    const pasted = paste({
      menuId: this.menuId,
      servings,
      copiedRecipes: extractTruthyKeys(copiedRecipesById),
      copiedDays: extractTruthyKeys(copiedDays),
      selectedDays:
        currentViewBy === VIEW_BY.DAY
          ? [currentDay]
          : extractTruthyKeys(selectedDays),
    });
    if (pasted) {
      this.analyzeCycleMenu();
      this.resetSelectedDays();
    }
  };

  removeAllSelections = () => {
    const { clearSelection, resetCopied } = this.props;
    this.resetSelectedDays();
    clearSelection();
    resetCopied();
  };

  openModal = (modalType, callback) => {
    const newModalStates = Object.keys(Modals).reduce((state, modalType) => {
      state[modalType] = false;
      return state;
    }, {});

    this.setState({ ...newModalStates, [modalType]: true }, callback);
  };

  closeModal = (modalType, callback) => {
    this.setState({ [modalType]: false }, callback);
  };

  get isReadOnly() {
    const { isReadOnly, isMenuReadOnly } = this.props;
    return isReadOnly || isMenuReadOnly;
  }

  get isToolbarHidden() {
    const { isSharedMenu } = this.props;
    return this.isReadOnly && !isSharedMenu;
  }

  handleLassoClick = () => {
    this.props.toggleLasso();
    this.props.toggleBlockOnClick();
  };

  render() {
    const {
      // withRecipesSubscription props
      recipeCategories,
      recipeSources,
      recipeGroups,
      searchRecipes,
      searchResults,
      loadingRecipes,
      hasNextPage,
      isSharedMenu,

      analysisDays,
      menuTitle,
      numberOfDays,
      fetching,
      selectedRecipesById,
      recipesById,
      reimbMealsByDayMap,
    } = this.props;
    const {
      ready,
      disableHoverOver,
      searchItemsOnMenus,
      dailyViewDay,
      showDaysOfTheWeek,
      [Modals.RecipeSearch]: showRecipeSearch,
      [Modals.ApplyModal]: showApplyModal,
      [Modals.UnApplyModal]: showUnApplyModal,
      [Modals.ReimbursableMealModal]: showReimbursableMealModal,
      [Modals.AnalysisReportModal]: showAnalysisReportModal,
      [Modals.RecipeModal]: showRecipeModal,
      [Modals.ReplaceRemove]: showReplaceRemoveModal,
    } = this.state;

    if (fetching || !ready) {
      return <LoadingBase />;
    }

    const showEditButton =
      !this.isReadOnly && this.menuType !== EDIT_MENU_TYPES.APPLIED_MENU;

    // TODO Remove this when handling isite updates for applied menus
    const showApply = this.menuType !== EDIT_MENU_TYPES.APPLIED_MENU;

    return (
      <div id="edit-cycle-menu">
        <EditMenuForm onSubmit={this.saveMenu} />
        <div
          className={classNames('menu-header-container', {
            'toolbar-hidden': this.isToolbarHidden,
          })}
        >
          <div className="menu-header-container-fixed">
            <Header className="menu-header" size="large">
              <span>{this.menuHeaderText}</span>
              {showEditButton && (
                <DirtyWrapper manual isReadOnly={this.isReadOnly}>
                  {(showDirtyConfirm, showDirtyLinkConfirm) => (
                    <Button
                      className="menu-edit-btn"
                      onClick={this.onEditClick(showDirtyLinkConfirm)}
                    >
                      Edit
                    </Button>
                  )}
                </DirtyWrapper>
              )}
            </Header>
            {!this.isToolbarHidden && (
              <div className="menu-toolbar">
                <div className="menu-toolbar-row">
                  {showApply && (
                    <Fragment>
                      <div
                        className="menu-icon-btn"
                        onClick={this.onApplyClick}
                      >
                        <Icon name="sitemap" size="large" />
                        Apply
                      </div>
                    </Fragment>
                  )}
                  {showApply && (
                    <Fragment>
                      <div
                        className="menu-icon-btn"
                        onClick={this.onUnApplyClick}
                      >
                        <Icon name="undo" size="large" />
                        Un-Apply
                      </div>
                    </Fragment>
                  )}
                  {!this.isReadOnly && (
                    <Fragment>
                      <div className="menu-toolbar-divider" />
                      <div
                        className="menu-icon-btn"
                        onClick={this.onDragNDropClick}
                      >
                        <Icon name="search" size="large" />
                        Recipe Search
                      </div>
                      <div className="menu-toolbar-divider" />
                      <div
                        className="menu-icon-btn"
                        onClick={this.selectAllDays}
                      >
                        <Icon name="calendar alternate outline" size="large" />
                        {this.allDaysSelected ? 'Unselect' : 'Select'} All Days
                      </div>
                      <div
                        className="menu-icon-btn"
                        onClick={this.handleLassoClick}
                      >
                        <Icon name="object group outline" size="large" />
                        Select Items
                      </div>
                      <Popup
                        openDelay={500}
                        trigger={
                          <div className="menu-icon-btn" onClick={this.copy}>
                            <Icon name="copy outline" size="large" />
                            Copy
                          </div>
                        }
                        content={`${MOD_KEY}+C`}
                        position="bottom center"
                      />
                      <Popup
                        openDelay={500}
                        trigger={
                          <div className="menu-icon-btn" onClick={this.paste}>
                            <Icon name="paste" size="large" />
                            Paste
                          </div>
                        }
                        content={`${MOD_KEY}+V`}
                        position="bottom center"
                      />
                      <Popup
                        openDelay={500}
                        trigger={
                          <div
                            className="menu-icon-btn"
                            onClick={this.removeAllSelections}
                          >
                            <Icon name="eraser" size="large" />
                            Clear Selected
                          </div>
                        }
                        content="Esc"
                        position="bottom center"
                      />

                      <Popup
                        openDelay={500}
                        trigger={
                          <div
                            className="menu-icon-btn"
                            onClick={this.deleteSelectedRecipes}
                          >
                            <Icon name="trash" size="large" />
                            Delete
                          </div>
                        }
                        content="Backspace or Delete"
                        position="bottom center"
                      />
                      <div
                        className="menu-icon-btn"
                        onClick={() => {
                          this.setState({
                            [Modals.ReplaceRemove]: true,
                            [Modals.RecipeSearch]: false,
                          });
                        }}
                      >
                        <Icon name="exchange" size="large" />
                        Remove / Replace
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <DragDropContext
          onDragEnd={this.onDragEnd}
          onDragStart={this.onDragStart}
        >
          <div className="menu-section">
            {showRecipeSearch && (
              <RecipeSearch
                ref={this.recipeSearchRef}
                className="menu-search-container"
                onSearchCloseClick={this.onSearchCloseClick}
                recipeCategories={recipeCategories}
                recipeSources={recipeSources}
                recipeGroups={recipeGroups}
                searchRecipes={searchRecipes}
                searchResults={searchResults}
                loadingRecipes={loadingRecipes}
                hasNextPage={hasNextPage}
                droppableId={this.searchDroppableId}
                onAddRecipe={this.onAddRecipeClick}
                onUnmount={this.onRecipeSearchUnmount}
                rootContainerProps={{
                  onKeyDown: this.onRecipeSearchKeyDown,
                }}
                disableHoverOver={disableHoverOver}
                onDisableHoverOver={this.onDisableHoverOver}
                searchItemsOnMenus={searchItemsOnMenus}
                onSearchItemsOnMenuChange={this.onSearchItemsOnMenuChange}
              />
            )}
            {this.renderMenuOptions()}
            <Grid padded className="menu-grid">
              {this.renderView()}
            </Grid>
          </div>
        </DragDropContext>
        <div className="menu-toolbox-container">
          <Toolbox {...this.toolboxProps} />
        </div>
        <LassoSelection
          selectedRecipesById={selectedRecipesById}
          selectMenuItems={this.selectMenuItems}
        />
        <ApplyCycleMenuModal
          modalProps={{
            size: 'large',
            open: showApplyModal,
            onClose: this.onApplyClose,
          }}
          headerTitle={this.menuHeaderText}
          menuId={this.menuId}
          isSharedMenu={isSharedMenu}
          numberOfDaysInCycle={numberOfDays}
        />

        <UnApplyCycleMenuModal
          modalProps={{
            size: 'large',
            open: showUnApplyModal,
            onClose: this.onUnApplyClose,
          }}
          headerTitle={this.menuHeaderText}
          menuId={this.menuId}
          isSharedMenu={isSharedMenu}
          numberOfDaysInCycle={numberOfDays}
        />
        <ReimbursableMealModal
          modalProps={{
            open: showReimbursableMealModal,
            onClose: this.closeReimbursableMealModal,
          }}
          recipesById={recipesById}
          dailyViewDay={dailyViewDay}
          menuTitle={menuTitle}
          meals={getMealsOnDay(reimbMealsByDayMap, dailyViewDay)}
          analyzeCycleMenu={this.debouncedAnalyzeCycleMenu}
          showDaysOfTheWeek={showDaysOfTheWeek}
          analysisDays={analysisDays}
          isReadOnly={this.isReadOnly}
        />
        <AnalysisReportModal
          modalProps={{
            size: 'large',
            open: showAnalysisReportModal,
            onClose: () => this.closeModal(Modals.AnalysisReportModal),
          }}
          headerTitle={this.menuHeaderText}
          numberOfDays={numberOfDays}
          menuId={this.menuId}
          isReadOnly={this.isReadOnly}
        />
        <RecipeModal
          modalProps={{
            size: 'fullscreen',
            open: showRecipeModal,
            onClose: this.closeRecipe,
          }}
        />
        {showReplaceRemoveModal && (
          <ReplaceRemoveModal
            modalProps={{
              open: showReplaceRemoveModal,
              onClose: () => this.closeModal(Modals.ReplaceRemove),
            }}
            analyzeMenu={this.analyzeCycleMenu}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    numberOfDays: EditMenuSelectors.getNumberOfDays(state),
    menuTitle: EditMenuSelectors.getMenuTitle(state),
    servings: EditMenuSelectors.getServings(state),
    fiscalYear: EditMenuSelectors.getFiscalYear(state),
    nutritionStandardId: EditMenuSelectors.getNutritionStandardId(state),
    fetching: EditMenuSelectors.getFetching(state),
    analysisDays: EditMenuSelectors.getAnalysisDays(state),
    menuDaysMap: EditMenuSelectors.getMenuDaysMap(state),
    selectedRecipesById: CommonMenusSelectors.getSelectedRecipesById(state),
    copiedRecipesById: CommonMenusSelectors.getCopiedRecipesById(state),
    copiedDays: CommonMenusSelectors.getCopiedDays(state),
    isDragging: getIsDragging(state),
    draggingMeta: getDraggingMeta(state),
    saveSuccessful: EditMenuSelectors.getSaveSuccessful(state),
    error: EditMenuSelectors.getError(state),
    recipesById: EditMenuSelectors.getRecipesById(state),
    weeklyRequirements: EditMenuSelectors.getWeeklyRequirements(state),
    unmetDailyRequirements: EditMenuSelectors.getUnmetDailyRequirements(state),
    dailyContributions: EditMenuSelectors.getDailyContributions(state),
    analyzing: EditMenuSelectors.getAnalyzing(state),
    MnuEditMenuUserSettings: getMnuEditMenuUserSettings(state),
    recipeCountByDayMap: EditMenuSelectors.getRecipeCountByDayMap(state),
    deleteRecipeDisabled: EditMenuSelectors.getDisableDeleteRecipe(state),
    reimbMealsByDayMap: EditMenuSelectors.getReimbMealsByDayMap(state),
    editableAppliedDays: EditMenuSelectors.getEditableAppliedDays(state),
    isMenuReadOnly: EditMenuSelectors.getIsReadOnly(state),
    isSharedMenu: EditMenuSelectors.getIsSharedMenu(state),
    isFormDirty: getIsDirty(EDIT_MENU_FORM_NAME),
    lassoMode: LassoSelectors.getLassoSelectionMode(state),
    blockOnClick: LassoSelectors.getBlockOnClick(state),
    schoolCalendar: EditMenuSelectors.getSchoolCalendar(state),
  };
};

// https://react-redux.js.org/using-react-redux/connect-mapdispatch#manually-injecting-dispatch
const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(
    {
      ...EditMenuActions,
      ...CommonMenusActions,
      setEditCycleValues,
      setEditing,
      setSaveSuccessful,
      resetDirty,
      clearRecipes,
      setIsDragging,
      toggleLasso,
      toggleBlockOnClick,
      change,
      setNotificationDialog,
      setMnuEditMenuUserSettings,
    },
    dispatch
  ),
});

EditMenu = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRecipesSubscription(EditMenu))
);

// See https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
// for why this is not part of the component
EditMenu.path = '/managemenu/edit/:menuId';

export { EditMenu };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/EditMenu.js